import React from 'react';
import { FiPlus, FiEye, FiTrash2, FiEdit2 } from 'react-icons/fi';
import LoadingSpinner from './LoadingSpinner';

const TemplatesTab = ({
  activeTab,
  emailTemplates,
  smsTemplates,
  setEmailForm,
  setSmsForm,
  setTemplateForm,
  setActiveSubTab,
  handleDeleteTemplate,
  setTemplateModalType,
  setEditingTemplate,
  setShowTemplateModal,
  dataLoading
}) => {
  const templates = activeTab === 'email' ? emailTemplates : smsTemplates;
  const title = activeTab === 'email' ? 'Email Şablonları' : 'SMS Şablonları';

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-semibold">{title}</h3>
        <button
          onClick={() => {
            setEditingTemplate(null);
            setTemplateForm({ name: '', subject: '', body: '', content: '' });
            setTemplateModalType(activeTab);
            setShowTemplateModal(true);
          }}
          className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors"
        >
          <FiPlus className="inline mr-2" />
          Yeni Şablon
        </button>
      </div>

      {dataLoading.templates ? (
        <LoadingSpinner />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {templates.map(template => (
            <div key={template.id} className="bg-white border rounded-lg p-4 hover:shadow-lg transition-shadow">
              <h4 className="font-semibold text-gray-800 mb-2">{template.name}</h4>
              {activeTab === 'email' && (
                <p className="text-sm text-gray-600 mb-2">Konu: {template.subject}</p>
              )}
              <p className="text-sm text-gray-600 line-clamp-3">
                {activeTab === 'email' ? template.body : template.content}
              </p>
              <div className="mt-4 flex justify-end space-x-2">
                <button
                  onClick={() => {
                    if (activeTab === 'email') {
                      setEmailForm({
                        template_id: template.id,
                        custom_subject: template.subject,
                        custom_body: template.body
                      });
                    } else {
                      setSmsForm({
                        template_id: template.id,
                        custom_message: template.content
                      });
                    }
                    setActiveSubTab('send');
                  }}
                  className="text-purple-600 hover:text-purple-700"
                  title="Kullan"
                >
                  <FiEye className="w-4 h-4" />
                </button>
                <button
                  onClick={() => {
                    setTemplateModalType(activeTab);
                    setEditingTemplate({ id: template.id, type: activeTab });
                    setTemplateForm({
                      name: template.name || '',
                      subject: activeTab === 'email' ? (template.subject || '') : '',
                      body: activeTab === 'email' ? (template.body || '') : '',
                      content: activeTab === 'sms' ? (template.content || '') : ''
                    });
                    setShowTemplateModal(true);
                  }}
                  className="text-blue-600 hover:text-blue-700"
                  title="Düzenle"
                >
                  <FiEdit2 className="w-4 h-4" />
                </button>
                <button
                  onClick={() => handleDeleteTemplate(template.id, activeTab)}
                  className="text-red-600 hover:text-red-700"
                  title="Sil"
                >
                  <FiTrash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
          {templates.length === 0 && (
            <div className="col-span-full text-center py-8 text-gray-500">
              Henüz şablon oluşturulmamış.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TemplatesTab;
